"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/navigation";
import { useLocale, useTranslations } from "next-intl";
import { getSocialProfiles } from "@/lib/social-profiles";
import { CookieSettingsLink } from "@/components/consent/CookieBanner";
import MadeWithLine from "@/components/upload/MadeWithLine";
import { MADE_WITH_SPOTS, type MadeWithArm } from "@/lib/made-with";
import { getUploadWindow } from "@/lib/upload-window";
import WithdrawalLink from "@/components/withdrawal/WithdrawalLink";
interface FooterProps {
  /** Links to the guides and the comparison. Off on guest upload pages. */
  hasSiteLinks?: boolean;
  /**
   * Set only by the guest upload page: arm B of «Made with Guest.Gallery»
   * (approval 316) shows the line above the © row, unless the event has closed
   * (the closed gallery shows it instead).
   */
  guestPage?: {
    madeWithArm: MadeWithArm;
    archivesAt: string | null;
  };
  /**
   * The «Fortryd aftale» link (approval 390; founder 5 Nov, approval 393:
   * the homepage footer only). Set only by the homepage.
   */
  hasWithdrawalLink?: boolean;
}
export default function Footer(t0) {
  const $ = _c(52);
  const {
    hasSiteLinks: t1,
    guestPage,
    hasWithdrawalLink: t2
  } = t0;
  const hasSiteLinks = t1 === undefined ? false : t1;
  const hasWithdrawalLink = t2 === undefined ? false : t2;
  const t = useTranslations("Footer");
  const t3 = useLocale();
  let t4;
  if ($[0] !== t3) {
    t4 = getSocialProfiles(t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const socialProfiles = t4;
  let t5;
  if ($[2] !== guestPage) {
    t5 = guestPage?.madeWithArm === MADE_WITH_SPOTS.guestFooter && !getUploadWindow({
      archivesAt: guestPage.archivesAt
    }).isArchived;
    $[2] = guestPage;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const showsMadeWith = t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <hr className="" />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== showsMadeWith) {
    t7 = showsMadeWith && <MadeWithLine spot={MADE_WITH_SPOTS.guestFooter} className="-mb-4 self-start" />;
    $[5] = showsMadeWith;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = new Date().getFullYear();
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t) {
    t9 = t("allRightsReserved");
    $[8] = t;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <p>© {t8} Guest.Gallery, {t9}</p>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== hasSiteLinks || $[13] !== t) {
    t11 = hasSiteLinks ? <><Link className="underline" href="/blog">{t("guides")}</Link><Link className="underline" href="/sammenligning">{t("comparison")}</Link></> : null;
    $[12] = hasSiteLinks;
    $[13] = t;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t) {
    t12 = t("privacyPolicy");
    $[15] = t;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12) {
    t13 = <Link className="underline" href="/privacy-policy">{t12}</Link>;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t) {
    t14 = t("termsAndConditions");
    $[19] = t;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14) {
    t15 = <Link className="underline" href="/terms-and-conditions">{t14}</Link>;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== guestPage || $[24] !== hasWithdrawalLink) {
    t16 = hasWithdrawalLink && !guestPage ? <WithdrawalLink className="underline" /> : null;
    $[23] = guestPage;
    $[24] = hasWithdrawalLink;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <CookieSettingsLink className="text-left underline" />;
    t18 = <a className="underline" href="https://replysky.com/?utm_source=guestgallery&utm_medium=referral&utm_campaign=footer" target="_blank" rel="noopener noreferrer">Replysky</a>;
    $[26] = t17;
    $[27] = t18;
  } else {
    t17 = $[26];
    t18 = $[27];
  }
  let t19;
  if ($[28] !== socialProfiles.instagram) {
    t19 = <a className="underline" href={socialProfiles.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>;
    $[28] = socialProfiles.instagram;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== socialProfiles.facebook) {
    t20 = <a className="underline" href={socialProfiles.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>;
    $[30] = socialProfiles.facebook;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== t11 || $[33] !== t13 || $[34] !== t15 || $[35] !== t16 || $[36] !== t19 || $[37] !== t20) {
    t21 = <div className="flex flex-col md:flex-row gap-4 md:max-lg:flex-wrap md:max-lg:gap-y-2 md:max-lg:whitespace-nowrap">{t11}{t13}{t15}{t16}{t17}{t18}{t19}{t20}</div>;
    $[32] = t11;
    $[33] = t13;
    $[34] = t15;
    $[35] = t16;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t10 || $[40] !== t21) {
    t22 = <div className="flex justify-between gap-4 flex-wrap">{t10}{t21}</div>;
    $[39] = t10;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t22 || $[43] !== t7) {
    t23 = <div className="p-4  flex flex-col gap-8 mx-auto">{t6}{t7}{t22}</div>;
    $[42] = t22;
    $[43] = t7;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t) {
    t24 = t("companyLine");
    $[45] = t;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t24) {
    t25 = <div className="mx-4 text-sm text-gray-500">{t24}</div>;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t23 || $[50] !== t25) {
    t26 = <div className=" w-full  py-8">{t23}{t25}</div>;
    $[49] = t23;
    $[50] = t25;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  return t26;
}